import React from 'react';
import { X, Download, Smartphone, Plus, Share } from 'lucide-react';
import { useAppDownloadBanner } from '@/hooks/useAppDownloadBanner';
import { useEmailConfirmationBanner } from '@/hooks/useEmailConfirmationBanner';
import { Button } from '@/components/ui/button';

export function AppDownloadBanner() {
  const { isVisible, platform, dismissBanner, openAppStore, installPWA, hasPWAPrompt } = useAppDownloadBanner();
  const { isVisible: isEmailBannerVisible } = useEmailConfirmationBanner();

  console.log('🖼️ [AppDownloadBanner] Component render:', { isVisible, platform, hasPWAPrompt });

  if (!isVisible) {
    console.log('👻 [AppDownloadBanner] Not visible, returning null');
    return null;
  }

  console.log('🎨 [AppDownloadBanner] Rendering banner for platform:', platform);

  const renderContent = () => {
    if (platform === 'pwa' && hasPWAPrompt) {
      return (
        <>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium">Installer l'app Clan</p>
            <p className="text-xs opacity-90">Accès rapide depuis votre écran d'accueil</p>
          </div>
          <Button
            onClick={installPWA}
            variant="ghost"
            size="sm"
            className="text-primary-foreground hover:bg-white/20 px-3 py-1 h-auto text-xs"
          >
            <Plus className="h-3 w-3 mr-1" />
            Installer
          </Button>
        </>
      );
    }

    if (platform === 'ios') {
      const isIOSSafari = /Safari/.test(navigator.userAgent) && !/Chrome|CriOS|EdgiOS|FxiOS/.test(navigator.userAgent);
      
      if (isIOSSafari) {
        return (
          <>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium">Installer l'app Clan</p>
              <p className="text-xs opacity-90">Appuyez sur <Share className="inline h-3 w-3 mx-1" /> puis "Sur l'écran d'accueil"</p>
            </div>
          </>
        );
      } else {
        // Chrome on iOS - Show App Store option
        return (
          <>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium">App Clan disponible</p>
              <p className="text-xs opacity-90">Téléchargez depuis l'App Store</p>
            </div>
            <Button
              onClick={openAppStore}
              variant="ghost"
              size="sm"
              className="text-primary-foreground hover:bg-white/20 px-3 py-1 h-auto text-xs"
            >
              <Download className="h-3 w-3 mr-1" />
              App Store
            </Button>
          </>
        );
      }
    }

    if (platform === 'android') {
      return (
        <>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium">App Clan</p>
            <p className="text-xs opacity-90">Installation PWA disponible</p>
          </div>
        </>
      );
    }

    return null;
  };

  return (
    <div 
      className="fixed left-0 right-0 z-50 bg-gradient-to-r from-primary to-primary-glow text-primary-foreground shadow-lg transform transition-all duration-300 ease-out"
      style={{
        top: isEmailBannerVisible ? '60px' : '0',
        paddingTop: !isEmailBannerVisible ? 'env(safe-area-inset-top, 0px)' : '0'
      }}
    >
      <div className="flex items-center justify-between px-4 py-3">
        <div className="flex items-center space-x-3 flex-1">
          <div className="flex-shrink-0">
            <Smartphone className="h-5 w-5" />
          </div>
          {renderContent()}
        </div>
        
        <div className="flex items-center space-x-2 ml-2">
          <Button
            onClick={dismissBanner}
            variant="ghost"
            size="sm"
            className="text-primary-foreground hover:bg-white/20 p-1 h-auto"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}